var req = require("!!/Users/dw/Exploros/front-end/webpack/loaders/pug-template-loader.js!/Users/dw/Exploros/front-end/elements/tao_assessment/template.jade");
module.exports = (req['default'] || req).apply(req, [])